import { useContext } from 'react';
import { IToggleButtonGroupContext } from './types';
import { ToggleButtonGroupContext } from './ToggleButtonGroup';

export const useToggleButtonGroup = (): IToggleButtonGroupContext => {
  const context = useContext(ToggleButtonGroupContext);

  if (!context) {
    throw new Error('This component must be a <ToggleButtonGroup> component');
  }

  return context;
};
